<template>
  <div class="asset-page">
    <AssetWrapper />
  </div>
</template>

<script>
import AssetWrapper from '@/wrappers/AssetWrapper.vue';

export default {
  name: 'AssetPage',
  components: {
    AssetWrapper,
  },
  computed: {
    assetHash() {
      return this.$route.params.asset || '';
    },
  },
  data() {
    return {
        // Define your component data here
    };
  },
  methods: {
    // Add your methods here
  },
  mounted() {
    // Lifecycle hook for when the component is mounted
  },
};
</script>

<style scoped>
.asset-view {
    /* Add your styles here */
}
</style>